<template>
	<div class="layout-header" :style="navBgColor">
		<div :class="className">
			<div class="layout-header-left" @click="goHome" style="cursor: pointer;">
				<div class="layout-header-logo">
					<img src="@/assets/img/logo.png" alt="" style="display: block;float: left;margin-top: 4px;"/>
					<div style="display: flex;">
						<div style="font-size: 42px;margin-left: 10px;">易企飞</div>
						<div class="logo-cont">
							<div class="logo-title">重庆市大渡口区一站式</div>
							<div class="logo-subtitle">产业信息公共服务平台</div>
						</div>
					</div>
				</div>
			</div>
			<div class="layout-header-right">
				<div v-if="showClose==false" class="layout-header-item">
					<div @click="routePage('/home')" :class="Active=='/home' && 'isActive'">首页</div>
				</div>
				<div v-if="showClose==false" class="layout-header-item">
					<div @click="routePage('/gov')" :class="Active=='/gov' && 'isActive'">政务中心</div>
				</div>
				<div v-if="showClose==false" class="layout-header-item">
					<div @click="routePage('/product')" :class="Active=='/product' && 'isActive'">商务中心</div>
				</div>
				<div v-if="showClose==false" class="layout-header-item">
					<div @click="routePage('/news')" :class="Active=='/news' && 'isActive'">资讯中心</div>
				</div>
				<div v-if="showClose==false" class="layout-header-item">
					<div @click="routePage('/user')" :class="Active.indexOf('/user')>=0 && 'isActive'">用户中心</div>
				</div>
				<div v-if="showClose==false" class="header-information" style="position: relative;" @click="showChat">
					<img src="@/assets/img/bell.png" alt="" />
					<div v-if="count>0" style="width: 10px;height: 10px;border-radius: 10px;background-color: red;position: absolute;right: 0px;top:0px;">&nbsp;</div>
				</div>
				<i v-if="showClose" @click="closeWindow" style="float: right;font-size: 24px;cursor: pointer;" class="el-icon-close"></i>
			</div>
		</div>
		<el-dialog title="在线咨询" class="chat" :visible.sync="isShowChat" width="500px" top="10vh" :append-to-body="true">
			<iframe v-if="isShowChat" src="https://i-ddk.com/chat" style="width: 100%; height: 70vh; border: medium none"></iframe>
		</el-dialog>
	</div>
</template>

<script>
import {Api} from "../utils/axios.js"
export default {
	data() {
		return {
			isShowChat:false,
			isShowHeader:true,
			isShowLogin:false,
			Active:'',
			headerBgColor:1,
			showClose:false,
			className:'layout-header-wrapper',
			count:0
		}
	},
	computed: {
		navBgColor() {
			if (this.headerBgColor==2)
				return {
					backgroundColor: '#4a73ff',
					boxShadow:' 0 2px 12px 0 rgba(0, 0, 0, 0.3)'
				}
			else
				return {
					backgroundColor: 'transparent'
				}
		}
	},
	methods: {
		showChat(){
			if(sessionStorage.getItem('uid')==null){
				try{
					this.$parent.$parent.$parent.showLogin()
				}catch(e){
					this.$parent.$parent.showLogin()
				}
				return
			}
			this.isShowChat = true
		},
		routePage(page){
			if(page=='/user'){
				if(sessionStorage.getItem('uid')==null){
					try{
						this.$parent.$parent.$parent.showLogin()
					}catch(e){
						this.$parent.$parent.showLogin()
					}
					return
				}
			}
			this.Active = page
			this.$router.replace({path:page})
		},
		closeWindow(){
			window.close()
		},
		refreshChat(){
			Api('user/chat',{uid:sessionStorage.getItem('uid'),token:sessionStorage.getItem('token')}).then((res) => {
				if(res.code==200){
					this.count = res.result.count
				}else{
					this.$message.error(res.msg);
				}
			})
		},
		goHome(){
			console.log("into")
			this.$router.replace('./')
		}
	},
	mounted:function(){
		this.Active = this.$route.path
		if (this.Active !== '/home'){
			this.headerBgColor = 2
		} 
		if (this.Active.indexOf('Detail')>=0||(this.Active.indexOf('Edit')>=0&&this.Active.indexOf('company')<0)||this.Active.indexOf('issueReply')>=0||(this.Active.indexOf('issue')>=0&&this.Active.indexOf('user')<0)){
			this.showClose = true
		}else{
			this.showClose = false
		} 
		if(this.Active.indexOf("user")>=0){
			this.className = 'layout-header-wrapper fullWidth'
		}else{
			this.className = 'layout-header-wrapper'
		}
		window.addEventListener('scroll', () => {
			if (this.Active !== '/home')return
			const scrollTop = document.documentElement.scrollTop>0 ? document.documentElement.scrollTop : document.body.scrollTop
			if (scrollTop > 100) {
			  this.headerBgColor = 2
			} else {
			  this.headerBgColor = 1
			}
		})
		this.refreshChat()
		setInterval(this.refreshChat, 1000);
	},
	watch:{
		$route(to,from){
			this.Active = to.path
			if(this.Active.indexOf("user")>=0){
				this.className = 'layout-header-wrapper fullWidth'
			}else{
				this.className = 'layout-header-wrapper'
			}
			if (this.Active.indexOf('Detail')>=0||this.Active.indexOf('Edit')>=0||this.Active.indexOf('issueReply')>=0||(this.Active.indexOf('issue')>=0&&this.Active.indexOf('user')<0)){
				this.showClose = true
			}else{
				this.showClose = false
			} 
			if (this.Active !== '/home'){
				this.headerBgColor = 2
				return
			} 
			this.headerBgColor = 1
		}
	}
}
</script>

<style scoped>
.logo-title,.logo-subtitle{font-size: 18px;}
.layout-header {
  color: #fff;
  font-size: 15px;
  height: 65px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  transition: all 0.3s;
}
.layout-header-wrapper{
	width: 1300px;
	height: 65px;
	margin: auto;
	display: flex;
	justify-content: space-between;
}
.layout-header-left{
    display: flex;
    align-items: center;
}
.layout-header-right{
	display: flex;
	align-items: center;
	flex-direction: row;
}
.layout-header-logo{
	display: flex;
	text-shadow:0 0 5px rgb(0 0 0 / 80%);
}
.layout-header-logo img{
	width: 50px;
	height: 50px;
}
.logo-cont {
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-left: 10px;
}
.layout-header-item{
	width: 94px;
	height: 100%;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 40px;
	font-size: 16px;
	text-shadow:0 0 5px rgb(0 0 0 / 8%);
}
.header-information {
    width: 50px;
    text-align: right;
    cursor: pointer;
}
.header-information img{
	width: 20px;
	height: 24px;
}
.isActive {
	font-size: 16px;
	border-bottom: 3px solid #fff;
}
</style>
